<template>
  <div class="page_404">
      <div class="image_box">
        <img :src="obj.maintenance_background" alt="">
      </div>
      <div class="title">{{obj.maintenance_title}}</div>
      <div class="desc">{{obj.maintenance_desc}}</div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: '',
  components: {

  },
  props: {},
  data () {
    return {
      isMaxScreen: true
    }
  },
  computed: {
    ...mapState({
      obj: state => state.blankData
    })
  },
  watch: {},
  created () {},

  mounted () {
    this.isMaxScreen = document.body.clientWidth > 850
    window.addEventListener('resize', () => {
      // console.log('外部', document.body.clientWidth)
      this.isMaxScreen = document.body.clientWidth > 850
      // console.log("this.isMaxScreen",this.isMaxScreen)
      // console.log(99999999999999999999999999999)
    })
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.page_404 {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.image_box {
  width: 765px;
  height: 358px;
}
img {
  width: 100%;
  height: 100%;
}
.title, .desc {
  text-align: center;
  font-size: 28px;
}
.desc {
  margin-top: 18px;
  font-size: 16px;
  color: #999;
}

@media all and (max-width: 750px) {
  .image_box {
    width: 77.33vw;
    height: 53.33vw;
    margin: 0 auto;
  }
}
</style>
